import { Grid } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getPlanTypeCountMetrics } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

const PlanTypeMetrics = () => {
  const [countsData, setCountsData] = useState<Record<string, number>>({});

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'id', hide: true },
    { field: 'planType', headerName: 'Plan Type', flex: 1 },
    { field: 'count', headerName: 'Count', flex: 1 },
  ];

  const tableData = useMemo(() => {
    const data = Object.keys(countsData).map((key) => ({
      id: uuidv4(),
      planType: key,
      count: countsData[key],
    }));
    return data;
  }, [countsData]);

  useEffect(() => {
    const fetchData = async () => {
      const req = await getPlanTypeCountMetrics();
      setCountsData(req.data);
    };
    fetchData();
  }, []);

  return (
    <Grid item xs={6} bgcolor={WsColors.White} height={500}>
      <WsTypography bold>Plan Type Count as of Today</WsTypography>
      <DataGrid
        columns={columns}
        rows={tableData}
        components={{ Toolbar: GridToolbar }}
        pageSize={10}
        rowsPerPageOptions={[5, 10, 20]}
      />
    </Grid>
  );
};

export default PlanTypeMetrics;
